import React from 'react';
import PropTypes from 'prop-types';
import Row from '../row';

export default class RowGroup extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    collapsed: PropTypes.bool,
    data: PropTypes.array,
    header: PropTypes.any,
  };

  static defaultProps = {
    children: null,
    collapsed: false,
    data: [],
    header: null,
  };

  static toRows(props) {
    const children = React.Children.toArray(props.children);
    let rows = [
      <Row
        data={props.data}
        header={props.header}
        isGroupHeader={true}
        key={`row-group-header-${props.header}`}
      />,
    ];

    if (!props.collapsed) {
      // Auto-generate children based on data row
      rows = rows.concat(children);
    }

    return rows;
  }

  render() {
    return RowGroup.toRows(this.props);
  }
}
